import { render, staticRenderFns } from "./HotelOne.vue?vue&type=template&id=4368042c&"
import script from "./HotelOne.vue?vue&type=script&lang=js&"
export * from "./HotelOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports